import { useState, useEffect } from "react";
import { useUserContext } from "../../../context/UserContext.jsx";
import { apiRequest } from "@/network/apiClient";
import { API_ENDPOINTS } from "@/api/apiEndpoints";
import { PickLeadIcon } from "../icons";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";

const PickLeadButton = ({leadId ,leadName, fromLeadTable}) => {

    const { userId } = useUserContext();
    const [isLoading, setIsLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({
        leadId: leadId,
    });

    // Set reset lead id and user id
    useEffect(() => {
        setFormData({
            leadId: leadId,
        });
    }, [leadId]);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const confirmPickLead = async () => {
        setIsLoading(true);
        try {
            const result = await apiRequest(`${import.meta.env.VITE_BASE_URL}/${API_ENDPOINTS.UPDATE_LEADS.LEAD_OWNER}`, 'POST', formData)

            closeModal();
            toast.success("Lead owner changed successfully!");

        } catch (error) {
        toast.error(error || "Error changing owner");

        } finally {
        setIsLoading(false);
        }
    };

    return (
        <div className="relative group">
            {/* Button to open the modal */}
            {fromLeadTable ? (
                <button
                    onClick={openModal}
                    className="text-[#1E293B] block px-4 py-2 text-sm hover:bg-[#F1F5F9] text-center w-full"
                >
                    <img src={PickLeadIcon} alt="Pick Lead" className="inline-block w-6 h-6 mr-2"/> Pick Lead
                </button>
            ):(
                <button
                    onClick={openModal}
                    className="py-3 px-5 rounded-full transition -m-6 text-lg font-bold bg-white text-black border-[1px] border-black  hover:bg-gray-50"
                >
                    <img src={PickLeadIcon} alt="Pick Lead" className="inline-block w-6 h-6 mr-2"/> Pick Lead
                </button>
            )}
            {/* Modal */}
            {isModalOpen && createPortal(
                <div className="flex fixed z-[50] inset-0 bg-black bg-opacity-50 flex items-center justify-center text-center">
                    <div className="bg-white p-6 rounded-lg w-1/3">
                        {/* Center the icon using Flexbox */}
                        <div className="flex justify-center mb-2 pt-6">
                            <img src="/icons/edit.svg" className='size-11' />
                        </div>
                        <h1 className="text-2xl font-bold mb-3 justify-center flex">Pick Lead</h1>
                        <span className="text-[#475569] flex flex-col">
                            <a>Are you sure you want to pick this lead?</a>
                            <b className="text-black">{leadName} #{leadId}</b>
                        </span>
                        <div className="mt-6 mb-6 ">
                            <button
                                className="text-black underline hover:text-blue-800 focus:outline-none"
                                onClick={closeModal}
                            >
                                <b>No, Don't Pick</b>
                            </button>
                        </div>
                        <button
                            className="bg-yellow-300 text-black py-4 w-full rounded-3xl hover:bg-yellow-400"
                            onClick={confirmPickLead}
                        >
                            <b>Confirm Pick</b>
                        </button>
                    </div>
                </div>,
                document.body
            )}
        </div>
    );
};

export default PickLeadButton;
